// 這是Webpack掛載起始點
import Index from './index.vue'
import Show from '@core_waybills/.components/customer/customer_show.vue'

const main_router = 'customer_core_waybills'
const show_router = 'customer_show_core_waybill'
const operation_main_router = 'customer_core_waybills_operation'

const router = [
    {
        path: '',
        component: Index,
        name: 'customer_core_waybills',
        meta: {
            breadcrumb: [main_router]
        }
    },
    {
        path: 'show/:identity',
        component: Show,
        name: 'customer_show_core_waybill',
        meta: {
            breadcrumb: [main_router, show_router]
        }
    },
    {
        // 訂單內的運單
        path: 'operation/:operation_number',
        component: Index,
        name: 'customer_core_waybills_operation',
        meta: {
            breadcrumb: [main_router, operation_main_router]
        }
    },
    {
        path: 'operation/:operation_number/show/:identity',
        component: Show,
        name: 'customer_show_core_waybill_operation',
        meta: {
            breadcrumb: [main_router, operation_main_router, show_router]
        }
    },
]

export default router
